import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Card, Table, Empty, Divider, Select } from 'antd';
import {Action} from 'fennec-ui'
import Filtered from '../Filtered'
import {DropdownAction} from 'fennec-ui'
import { GET, POST, queryFilterByItem, filterByItem, errorCatch } from 'fennec-ui'
import "./index.css"

import REDUX_KomissiiVYacheikakh from '../../../objects/KomissiiVYacheikakh/reducer';

import NovieKomissiiVYacheikakh from '../../forms/NovieKomissiiVYacheikakh'
import { createUseStyles } from 'react-jss';

const { Option } = Select;

const useStyles = createUseStyles({
    collapse: {
        '& .ant-collapse-content > .ant-collapse-content-box': {
            padding: "0px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header .ant-collapse-arrow': {
            top: "-3px",
            left: "10px"
        },
        '&.ant-collapse > .ant-collapse-item > .ant-collapse-header': {
            padding: "4px 10px",
            paddingLeft: "30px"
        }
    },
    cardSmall: {
        '& .ant-card-body': {
            padding: "0px"
        }
    }
})

function Btn(props) {
    const dispatch = useDispatch();
    const { create, object, sourceKey, auth, context, queryFilterContext } = props;
    const data = useSelector(REDUX_KomissiiVYacheikakh.selector.arrayByKey(sourceKey));
    return (
        <>
            <DropdownAction items={[
                {
                    title: "Удалить",
                    auth: auth,
                    mode: "MenuItem",
                    action: (values, unlock, close) => {
                        POST(auth, '/api/komissiivyacheikakh/delete', { ...object },
                            () => {
                                dispatch(REDUX_KomissiiVYacheikakh.actions.setArrayByKey(sourceKey, data.filter(item => item.ID !== object.ID)));
                            },
                            (err) => errorCatch(err)
                        );
                    }
                }
            ]} />
        </>
    )
};

export default function KomissiiVYacheikakhBlock(props) {
    const classes = useStyles()
    const dispatch = useDispatch();
    const { auth, source, create, context, sourceKey, queryFilterContext, title, size, object, soruceID } = props;
    const [loading, setLoading] = useState(false);

    const data = useSelector(REDUX_KomissiiVYacheikakh.selector.arrayByKey(sourceKey));
    const ctx = useSelector(state => state.home.cache[sourceKey]);

    const ctxChange = (value, option, array) => {
        if (context && context.collection) {
            dispatch({ type: 'cache', payload: { ...ctx, [sourceKey]: context.collection.find(item => item.ID === value) } });
        }
    };
    const ctxOptions = (context && context.collection) ? context.collection.map(item => {
        return (
            <Option value={item.ID} key={item.ID}>{(context.name) ? context.name(item) : ""}</Option>
        );
    }) : undefined;

    const concatSybmol = (source) => {
        return (source.indexOf("?") >= 0) ? "&" : "?";
    };
    useEffect(() => {
        let src = "";
        if (context && context.mix) {
            let q = queryFilterByItem(context.mix(ctx || {}));
            if (ctx || q) {
                src = source + ((ctx || q) ? concatSybmol(source) + q : "");
            }
        } else {
            src = source
        }
        if (src) {
            setLoading(true);
            GET(auth, src,
                ({ data }) => {
                    dispatch(REDUX_KomissiiVYacheikakh.actions.setArrayByKey(sourceKey, data));
                    setLoading(false);
                },
                (err) => errorCatch(err, setLoading(false)));
        }
    }, [ctx]);

    const filters = [
        // {
        //     name: "user.tgchatid",
        //     sort: true,
        //     filter: true,
        //     label:"Связан с телеграм",
        //     type: "object",
        //     relation: {
        //         display: (item) => {
        //             return item.name
        //         },
        //         reference: { data: [
        //             { ID: 1, name: "Да" },
        //             { ID: 2, name: "Нет" },
        //         ] },
        //         type: "many-one",
        //     },
        //     queryComparer: (value, item) => {
        //         if(value == 1){
        //             return "nnu"
        //         } else if(value == 2){
        //             return "nu"
        //         }
        //         return ""
        //     }
        // },
       
        {
            name: 'Активная',
            value: item => !item.yacheikaVUsluge.notActive, //(item.notActive) ? "Да" : "Нет",
            field: "active",
            type: "bool",
            filter: true
        },
        {
            name: 'Неактивная',
            value: item => item.yacheikaVUsluge.notActive, //(item.notActive) ? "Да" : "Нет",
            field: "notActive",
            type: "bool",
            filter: true
        }
    ];
    const columns = () => {
        var c = [];
        c.push({
            title: 'Название',
            render: (text, record, index) => {
                return (record.yacheikaVUsluge.nazvanie);
            }
        });
        c.push({
            title: 'Описание',
            render: (text, record, index) => {
                return (record.yacheikaVUsluge.opisanie);
            }
        });
        c.push({
            title: '',
            dataIndex: '',
            key: 'x',
            fixed: 'right',
            width: 45,
            render: (text, record, index) => (<Btn auth={auth} index={index + 1} object={record} create={create} sourceKey={sourceKey} context={context} queryFilterContext={(context && context.mix) ? context.mix(ctx || {}) : undefined} />),
        });
        return c;
    };
    const filterByContext = (e) => {
        if (context && context.mix) {
            if (!context) return true;
            if (!context.collection) {
                if (filterByItem(context.mix({}), e) === true) {
                    return true;
                }
            } else if (ctx) {
                if (filterByItem(context.mix(ctx), e) === true) {
                    return true;
                }
            }
        }
        return false;
    };
    const createAction = (values, unlock, close) => {
        POST(auth, "/api/komissiivyacheikakh/new", { ...values, ...((context) ? context.mix(ctx) : {}), ...((context) ? context.object(ctx) : {}) }, //values,
            ({ data }) => {
                if (data) {
                    dispatch(REDUX_KomissiiVYacheikakh.actions.updateArrayByKey(sourceKey, [data]));
                }
                close();
            },
            (err) => errorCatch(err, unlock));
    };
    const NewElement = () => (
        <Action
            {...props}
            mode={"button"}
            disabled={(context && context.collection && !ctx)}
            auth={auth}
            action={createAction}
            form={NovieKomissiiVYacheikakh}
            title={"Новая услуга"}
            modal={{
                width: "40%",
                minWidth: "400px",
                title: "Выбор услуги",
            }}
            context={context}
            sourceKey={sourceKey}
            soruceID={soruceID}
            queryFilterContext={(context && context.mix) ? context.mix(ctx || {}) : undefined}
            parentObject={object}
        />
    );
    return (
        <>
            <Filtered size={size} filters={filters} data={data /*(!context) ? data: data.filter(filterByContext)*/}
                addition={(create && size === "small") ? NewElement() : <></>}
                content={items => (
                    <div style={{ backgroundColor: "white", borderRadius: "4px" }}>
                    <div style={{ padding: "10px" }}>
                            {title || <Divider type="horizontal" orientation="left">Услуги</Divider>}
                            {create && <>
                                {size !== "small" && <div style={{ paddingBottom: "10px", display: "flex", justifyContent: "flex-end" }}>
                                    {(context && context.collection) && <div style={{ width: "100%", paddingRight: "5px" }}>
                                        <Select value={(ctx) ? ctx.ID : undefined} style={{ width: "100%" }} onChange={ctxChange}
                                        showSearch
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                            {ctxOptions}
                                        </Select>
                                    </div>}
                                    {NewElement()}
                                </div>}
                            </>}
                            <Table loading={loading} pagination={false} columns={columns()} dataSource={items} locale={{ emptyText: <Empty description={"Нет услуг"}></Empty> }} size="small" rowKey={(r) => r.ID} />
                        </div>
                    </div>
                )} />
        </>
    );
}
